import React from 'react'
import { Preloader } from '../../../Preloader'

export const TablePreloader = () => {
  return <Preloader enableHeader={true} columns={8} rows={3} />
}
